export const AreaTypeNoFlyZones = 'NO_FLY_ZONES';
export const AreaTypeGeoFences = 'GEO_FENCES';
export const AreaTypes = [AreaTypeNoFlyZones, AreaTypeGeoFences];
